import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, itemName }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 bg-foreground/60 z-[60]"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-[70] flex items-center justify-center p-4">
        <div className="bg-card rounded-lg border border-border elevation-3 w-full max-w-md transition-page">
          <div className="p-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 rounded-full bg-error/10 flex items-center justify-center">
                <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  Delete Inventory Item
                </h3>
                <p className="text-sm text-muted-foreground">
                  This action cannot be undone
                </p>
              </div>
            </div>

            <div className="bg-error/5 border border-error/20 rounded-lg p-4 mb-6">
              <p className="text-sm text-foreground mb-2">
                Are you sure you want to delete this item?
              </p>
              <p className="text-sm font-semibold text-foreground">
                {itemName}
              </p>
            </div>

            <div className="flex items-center gap-3">
              <Button
                variant="outline"
                fullWidth
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                variant="destructive"
                fullWidth
                onClick={onConfirm}
                iconName="Trash2"
                iconPosition="left"
                iconSize={16}
              >
                Delete Item
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeleteConfirmationModal;